import { Tag } from "../models"

import Vue from "vue"
import { Component, Prop } from "vue-property-decorator"

@Component({ name: "TagNavigatorItem" })
export default class extends Vue {
  @Prop() tag!: Tag
  @Prop({ default: false }) active!: boolean

  onClick() {
    this.$emit("click")
  }
}
